exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?modules&localIdentName=[name]_[local]_[hash:base64:5]!../../styles/typography.css"), undefined);

// module
exports.push([module.id, ".LoginForm_clear_1CgaT{\r\n  clear: both;\r\n}\r\n.LoginForm_root_3Vo8X {\r\n  max-width: 1200px;\r\n  margin-top: 20px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  padding: 20px 10px;\r\n  clear: both;\r\n}\r\n\r\n.LoginForm_serviceCode_2O-_3 {\r\n  padding-top: 8px;\r\n  padding-bottom: 16px;\r\n}\r\n\r\n.LoginForm_title_3ekgE {\r\n  padding-bottom: 16px;\r\n}\r\n.LoginForm_uvodH2_1vYkp {\r\n  font-size: 22px;\r\n  margin-bottom: 10px;\r\n}\r\n.LoginForm_panelHeaderFa_1b86o {\r\n  font-size: 18px !important;\r\n  width: 20px !important;\r\n}\r\n.LoginForm_userPanel_2mJvS {\r\n  background-color: #fcf8e3;\r\n  padding: 20px 10px;\r\n}\r\n.LoginForm_newUserPanel_3K0gc{\r\n  background-color: #d9edf7;\r\n  padding: 20px 10px;\r\n}\r\n.LoginForm_panelHeader_VO3v3 {\r\n  font-size: 40px;\r\n  margin-bottom: 15px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"clear": "LoginForm_clear_1CgaT",
	"root": "LoginForm_root_3Vo8X",
	"serviceCode": "LoginForm_serviceCode_2O-_3 " + require("-!../../../node_modules/css-loader/index.js?modules&localIdentName=[name]_[local]_[hash:base64:5]!../../styles/typography.css").locals["light"] + "",
	"title": "LoginForm_title_3ekgE " + require("-!../../../node_modules/css-loader/index.js?modules&localIdentName=[name]_[local]_[hash:base64:5]!../../styles/typography.css").locals["title"] + "",
	"uvodH2": "LoginForm_uvodH2_1vYkp",
	"panelHeaderFa": "LoginForm_panelHeaderFa_1b86o",
	"userPanel": "LoginForm_userPanel_2mJvS",
	"newUserPanel": "LoginForm_newUserPanel_3K0gc",
	"panelHeader": "LoginForm_panelHeader_VO3v3"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]_[local]_[hash:base64:5]!./src/components/login/LoginForm.css
// module id = 1153
// module chunks = 1